import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 */
export const logoutIfAlreadyIdentified = (): void => {
  Segment.logoutIfAlreadyIdentified();
};
